import {
  deleteStatus,
  getAllStatuses,
  newStatus,
  updateStatus,
} from '../../services/status';

export default {
  /**
   * Get All statuses
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchAllStatuses({ commit }) {
    const response = await getAllStatuses();
    commit('setProperty', { property: 'statuses', payload: response });
  },

  /**
   *
   * @param commit
   * @param statusId
   * @returns {Promise<void>}
   */
  async deleteStatus({ commit }, { statusId }) {
    await deleteStatus(statusId);
    commit('delProperty', { property: statusId });
  },

  /**
   *
   * @param context
   * @param statusId
   * @param status
   * @returns {Promise<void>}
   */
  async updateStatus(context, { statusId, status }) {
    await updateStatus(statusId, status);
  },

  /**
   *
   * @param context
   * @param status
   * @returns {Promise<void>}
   */
  async newStatus({ commit }, { status }) {
    const response = await newStatus(status);
    commit('setNewStatus', { payload: response });
  },
};
